import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  Organization,
} from '../../services/organizationApi';

interface DeleteOrganizationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  organization: Organization | null;
  loading: boolean;
}

const DeleteOrganizationDialog: React.FC<DeleteOrganizationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  organization,
  loading,
}) => {
  if (!organization) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Organization</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            This action cannot be undone. All organization data, members, and invitations will be permanently deleted.
          </Alert>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete the organization <strong>"{organization.name}"</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This will remove all members, invitations, and associated data. Only organization owners can perform this action.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Deleting...' : 'Delete Organization'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrganizationDialog;
